import React from 'react';
import { Badge, Box, Wrap, WrapItem } from '@chakra-ui/react';

/**
 * ConsolBadge - Pill Group style badge for Consol services.
 *
 * Renders pills for Consol EXP | Consol IMP | Oversea.
 *
 * @param {boolean} consolExport - Whether Consol Export is active
 * @param {boolean} consolImport - Whether Consol Import is active
 * @param {boolean} consolOversea - Whether Consol Oversea is active
 */
const ConsolBadge = ({ consolExport = false, consolImport = false, consolOversea = false }) => {
  const isAnyActive = consolExport || consolImport || consolOversea;

  const getPillStyles = (isActive) => {
    const activeBg = 'teal.100';
    const inactiveBg = 'gray.50';

    const activeColor = 'teal.800';
    const inactiveColor = 'gray.600';

    return {
      fontSize: 'xs',
      fontWeight: 'semibold',
      letterSpacing: '0.02em',
      px: 3,
      py: 1,
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      bg: isActive ? activeBg : inactiveBg,
      color: isActive ? activeColor : inactiveColor,
      borderWidth: '1px',
      borderColor: isActive ? 'teal.300' : 'gray.300',
      borderRadius: 'md',
      _hover: {
        bg: isActive ? 'teal.200' : 'gray.100'
      }
    };
  };

  return (
    <Box
      display="block"
      width="100%"
      borderWidth="1px"
      borderColor={isAnyActive ? 'teal.300' : 'gray.300'}
      borderRadius="md"
      boxShadow={isAnyActive ? '0 0 0 1px rgba(56, 178, 172, 0.2)' : 'none'}
      bg={isAnyActive ? 'teal.50' : 'white'}
      p={2}
      minH="44px"
      title="Consol Export / Import / Oversea"
    >
      <Wrap spacing={2} shouldWrapChildren>
        <WrapItem>
          <Badge {...getPillStyles(consolExport)} title="Consol Export">
            Consol EXP
          </Badge>
        </WrapItem>
        <WrapItem>
          <Badge {...getPillStyles(consolImport)} title="Consol Import">
            Consol IMP
          </Badge>
        </WrapItem>
        <WrapItem>
          <Badge {...getPillStyles(consolOversea)} title="Oversea">
            Oversea
          </Badge>
        </WrapItem>
      </Wrap>
    </Box>
  );
};

export default ConsolBadge;
